export default __webpack_public_path__ + "static/startup-leap-package-ea70d2e5d994dac6cc1fe068ba7b7bbb.png";